// extracted by mini-css-extract-plugin
export var searchHeader = "_75-0";
export var searchHeaderDark = "_75-1";